import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { PiMagnifyingGlassLight } from "react-icons/pi";
import { FaRegBell } from "react-icons/fa6";
import { RxHamburgerMenu } from "react-icons/rx";

import profile from "../../../../assets/images/svg/profile.jpg";
import logo from "../../../../assets/images/svg/datacode-logo.png";
import {
  SET_LOGOUT_USER,
  SET_LOGIN_USER_LOADING,
} from "../../../Authentication/constants";
import CreatorSideNav from "../CreatorSideNav";

const CreatorStudioHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const toggleSearch = () => setIsSearchOpen(!isSearchOpen);

  const [searchInput, setSearchInput] = useState("");

  const handleLogout = () => {
    dispatch({ type: SET_LOGOUT_USER });
    dispatch({ type: SET_LOGIN_USER_LOADING });
    navigate("/login");
  };

  return (
    <>
      <div className="row mr-0 creator-studio-header">
        <div className="col-12 col-md-12 col-lg-12 col-sm-12">
          <div className="row mx-0 header border-bottom">
            <RxHamburgerMenu
              className="col-2 d-md-none d-block"
              onClick={toggle}
              size={20}
            />
            <div className="col-5 col-md-2 py-0 px-0 px-md-3 header-logo">
              <Link to={"/"}>
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <div className="col-5 col-md-10 py-0 px-0 header-menu">
              <div className="d-md-block d-none search-input">
                <label htmlFor="search">
                  <PiMagnifyingGlassLight />
                  <input
                    type="text"
                    placeholder="search"
                    value={searchInput}
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                    }}
                  />
                </label>
              </div>
              <div className="information">
                <FaRegBell className="d-md-block d-none" />
                <PiMagnifyingGlassLight
                  size={22}
                  className="d-md-none d-block"
                  onClick={toggleSearch}
                />
                <img src={profile} alt="profile" />
                <button
                  className="btn btn-outline-danger"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
        {isSearchOpen && (
          <div className="mobile-search-input">
            <label htmlFor="search">
              <PiMagnifyingGlassLight />
              <input
                type="text"
                placeholder="Search"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
              />
            </label>
          </div>
        )}
      </div>
      <div className={`mobile-side-nav-drawer ${isOpen ? "open" : ""}`}>
        <div className="mobile-nav-header">
          <CreatorSideNav toggle={toggle} />
        </div>
      </div>
    </>
  );
};

export default CreatorStudioHeader;
